import { useEffect, useState, useRef } from 'react';
import Constant from '@/common/constant/Constant';
import { MenuItem, Menu } from '@material-ui/core';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';

function ListPublicRangeDropdown(props) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const [menuWidth, setMenuWidth] = useState(0);
    const menuTriggerRef = useRef(null);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
        setMenuWidth(menuTriggerRef.current.offsetWidth);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const onChangePremissionType = event => {
        setAnchorEl(null);
        let selectedSortType = event.currentTarget.innerText.trim();
        props?.handleSelectPermission(selectedSortType);
    };

    return (
        <div className="list-public-range">
            <div className="right-select-public-range"
                ref={menuTriggerRef}
                onClick={handleClick}
            >
                <div className="selected-options">{props?.selectPermission}</div>
                <div>
                    <img
                        src="/assets/image/chevron-down.svg"
                        alt=""
                        className={`${anchorEl && 'rotate-chevron'} chevron-icon`}
                    />
                </div>
            </div>
            <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                getContentAnchorEl={null}
                MenuListProps={{
                    className: 'menu-list-permision'
                }}
                PaperProps={{
                    style: {
                        marginTop: '2px',
                        width: `${menuWidth}px`,
                    }
                }}
            >
                <MenuItem
                    selected={
                        Constant.LIST_PERMISSION_PUBLIC_RANGE.BASIC_VIEW === props?.selectPermission
                    }
                    onClick={onChangePremissionType}
                >
                    <OverFlowTooltipWithTabsMui
                        value={Constant.LIST_PERMISSION_PUBLIC_RANGE.BASIC_VIEW}
                    />
                </MenuItem>
                <MenuItem
                    selected={
                        Constant.LIST_PERMISSION_PUBLIC_RANGE.BASIC_EDIT === props?.selectPermission
                    }
                    onClick={onChangePremissionType}
                >
                    <OverFlowTooltipWithTabsMui
                        value={Constant.LIST_PERMISSION_PUBLIC_RANGE.BASIC_EDIT}
                    />
                </MenuItem>
                <MenuItem
                    selected={
                        Constant.LIST_PERMISSION_PUBLIC_RANGE.ADDITIONAL_VIEW ===
                        props?.selectPermission
                    }
                    onClick={onChangePremissionType}
                >
                    <OverFlowTooltipWithTabsMui
                        value={Constant.LIST_PERMISSION_PUBLIC_RANGE.ADDITIONAL_VIEW}
                    />
                </MenuItem>
                <MenuItem
                    selected={
                        Constant.LIST_PERMISSION_PUBLIC_RANGE.ADDITIONAL_EDIT ===
                        props?.selectPermission
                    }
                    onClick={onChangePremissionType}
                >
                    <OverFlowTooltipWithTabsMui
                        value={Constant.LIST_PERMISSION_PUBLIC_RANGE.ADDITIONAL_EDIT}
                    />
                </MenuItem>
            </Menu>
        </div>
    );
}

export default ListPublicRangeDropdown;
